import { render, staticRenderFns } from "./_video.vue?vue&type=template&id=1edf53ae&"
import script from "./_video.vue?vue&type=script&lang=js&"
export * from "./_video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeroRadioVideo: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/hero/RadioVideo.vue').default,IconsArrowRight: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/ArrowRight.vue').default,RadioCarouselItem: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/radio/CarouselItem.vue').default,RadioCarousel: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/radio/Carousel.vue').default})
